var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 555,
    viewBox: "0 0 417 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M417 20C417 8.95429 408.046 0 397 0H20C8.95431 0 0 8.95431 0 20V535C0 546.046 8.95431 555 20 555H397C408.046 555 417 546.046 417 535V20Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.5 277.917C226.156 277.917 243.088 270.757 255.573 258.012C268.058 245.267 275.072 227.982 275.072 209.958C275.072 191.934 268.058 174.649 255.573 161.904C243.088 149.16 226.156 142 208.5 142C190.844 142 173.912 149.16 161.427 161.904C148.942 174.649 141.928 191.934 141.928 209.958C141.928 227.982 148.942 245.267 161.427 258.012C173.912 270.757 190.844 277.917 208.5 277.917ZM184.732 303.401C133.503 303.401 92 345.769 92 398.065C92 406.772 98.9175 413.833 107.447 413.833H309.554C318.083 413.833 325 406.772 325 398.065C325 345.769 283.497 303.401 232.268 303.401H184.732Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.f27911e2b105ffa2fc7d11931ea580c0.svg";
export { ForwardRef as ReactComponent };